import { getApiUrl } from '../config/api';
import { DEFAULT_UI_LANGUAGE } from '../i18n/language';

/** Forward returnTo / surface / UI language into the Google OAuth start URL. */
export function buildGoogleOAuthUrl(): string {
  const current = new URLSearchParams(window.location.search);
  const forwarded = new URLSearchParams();
  const returnTo = current.get('returnTo');
  const surface = current.get('surface');
  const langMatch = window.location.pathname.match(/^\/(fr|en)(?:\/|$)/);
  const lang = langMatch?.[1] || DEFAULT_UI_LANGUAGE;
  if (returnTo) forwarded.set('returnTo', returnTo);
  if (surface) forwarded.set('surface', surface);
  forwarded.set('lang', lang);
  const base = getApiUrl('/api/v1/auth/google');
  const qs = forwarded.toString();
  return qs ? `${base}?${qs}` : base;
}
